/**
 * Location_Service.ts
 * CRUD + lifecycle for hospitality locations (adapter /v1/locations).
 */

import { apiClient } from '../../api/axiosInstance';
import { Hosp_Locations_Url, Hosp_Location_Url } from '../../api/endpoints';
import type { Location, CreateLocationInput, UpdateLocationInput } from '../../schemas/config/location';

export const getLocations = async (): Promise<Location[]> => {
  const { data } = await apiClient.get<Location[]>(Hosp_Locations_Url);
  return data;
};

export const getLocation = async (id: string): Promise<Location> => {
  const { data } = await apiClient.get<Location>(Hosp_Location_Url(id));
  return data;
};

export const createLocation = async (input: CreateLocationInput): Promise<Location> => {
  const { data } = await apiClient.post<Location>(Hosp_Locations_Url, input);
  return data;
};

export const updateLocation = async (id: string, input: UpdateLocationInput): Promise<Location> => {
  const { data } = await apiClient.patch<Location>(Hosp_Location_Url(id), input);
  return data;
};

export const deactivateLocation = async (id: string): Promise<void> => {
  await apiClient.delete(Hosp_Location_Url(id));
};
